import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'MyTypes';

import { RoleManager } from '@portal/common/models/organization-roles';

export const getSession = (state: RootState) => state.session;

export const getIsImpersonatedSession = createSelector(
    getSession,
    (session) => session?.isImpersonated
);

export const getSessionAccount = createSelector(getSession, (session) => session?.account);

export const getSessionAccountId = createSelector(getSessionAccount, (account) => account?.id);

export const getIsStealthUser = createSelector(getSessionAccount, (account) => account?.is_stealth);

export const getIsNotFreshUser = createSelector(getSessionAccount, (account) => {
    if (!account) return false;
    const created = new Date(account.created);
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    return created <= oneWeekAgo;
});

export const getSessionError = (state: RootState) => state.sessionError;

export const isManager = createSelector(
    getSessionAccount,
    (account) => account?.organization_role === RoleManager
);

export const getIsNotificationShown = createSelector(
    getSessionAccount,
    (account) => account?.is_notification_shown
);
